@if (
  showAbonnementAndTilvalgChanges &&
  (upcomingChanges.hasServiceabonnementChanges ||
  upcomingChanges.hasTilvalgChanges ||
  upcomingChanges.hasOpkraevningsintervalChanges ||
  upcomingChanges.hasKundeOpkraevningModelChanges)
  ) {
  <div
    class="flex-wrap flex-wrap--between flex-wrap--align-center margin--bottom-s"
    >
    <div class="orange icon-with-text">
      <mat-icon svgIcon="obs-solid" class="icon-32"></mat-icon>
      Ændringerne træder i kraft d. {{ upcomingChanges.validFrom | date: 'dd.MM.yyyy' }}
    </div>
    @if (showRemoveAbonnementChangesButton) {
      <button [disabled]="!canRemove" class="btn-icon blue" (click)="removeAbonnementChanges()">
        <mat-icon svgIcon="undo" class="icon-32"></mat-icon>
        <span>Fortryd ændringer</span>
      </button>
    }
  </div>
}

<div class="flow__opt-detail flow__opt-detail--has-bg">
  @if (showAbonnementAndTilvalgChanges && upcomingChanges.hasServiceabonnementChanges) {
    <div class="flex-wrap flex-wrap--align-center">
      <div>
        <div>Serviceabonnement</div>
        <strong>{{ serviceaftale.serviceAbonnement.description }}</strong>
      </div>
      <div class="flow__arrow flow__arrow--no-hover">
        <mat-icon class="orange">chevron_right</mat-icon>
      </div>
      <div class="orange">
        <div>
          <div>Serviceabonnement</div>
          <strong>{{ upcomingChanges.upcomingServiceabonnement.description }}</strong>
        </div>
      </div>
    </div>
  }
  @if (showAbonnementAndTilvalgChanges && upcomingChanges.hasTilvalgChanges) {
    <div class="flex-wrap flex-wrap--align-center">
      <div>
        @if (upcomingChanges.currentTilvalg?.length > 0) {
          @for (tilvalg of upcomingChanges.currentTilvalg; track tilvalg) {
            <div>
              <strong>{{ tilvalg.name }}</strong>
            </div>
          }
        }
        @if (upcomingChanges.currentTilvalg?.length == 0) {
          <div>
            <strong>Ingen tilvalg</strong>
          </div>
        }
      </div>
      <div class="flow__arrow flow__arrow--no-hover">
        <mat-icon class="orange">chevron_right</mat-icon>
      </div>
      @if (upcomingChanges.upcomingTilvalg?.length > 0) {
        <div class="orange">
          @for (tilvalg of upcomingChanges.upcomingTilvalg; track tilvalg) {
            <div>
              <strong>{{ tilvalg.name }}</strong>
            </div>
          }
        </div>
      }
      @if (upcomingChanges.upcomingTilvalg?.length == 0) {
        <div class="orange">
          <div>
            <strong>Ingen tilvalg</strong>
          </div>
        </div>
      }
    </div>
  }

  @if (serviceaftale.naesteEftersynDate != upcomingChanges.naesteEftersynDate && upcomingChanges.hasServiceabonnementChanges) {
    <div
      class="flex-wrap flex-wrap--align-center"
      >
      <div>
        <div>Næste eftersyn</div>
        <strong>{{ serviceaftale.naesteEftersynDate | date: 'dd.MM.yyyy' }}</strong>
      </div>
      <div class="flow__arrow flow__arrow--no-hover">
        <mat-icon class="orange">chevron_right</mat-icon>
      </div>
      <div class="orange">
        <div>
          <div>Næste eftersyn</div>
          <strong>{{ upcomingChanges.naesteEftersynDate | date: 'dd.MM.yyyy' }}</strong>
        </div>
      </div>
    </div>
  }

  @if (serviceaftale.opkraevningDate != upcomingChanges.opkraevningDate && upcomingChanges.hasServiceabonnementChanges) {
    <div
      class="flex-wrap flex-wrap--align-center"
      >
      <div>
        <div>Opkrævningsdato</div>
        <strong>{{ serviceaftale.opkraevningDate | date: 'dd.MM.yyyy' }}</strong>
      </div>
      <div class="flow__arrow flow__arrow--no-hover">
        <mat-icon class="orange">chevron_right</mat-icon>
      </div>
      <div class="orange">
        <div>
          <div>Opkrævningsdato</div>
          <strong>{{ upcomingChanges.opkraevningDate | date: 'dd.MM.yyyy' }}</strong>
        </div>
      </div>
    </div>
  }

  @if (
    upcomingChanges.currentOpkraevningsinterval != upcomingChanges.upcomingOpkraevningsinterval &&
    upcomingChanges.hasOpkraevningsintervalChanges
    ) {
    <div
      class="flex-wrap flex-wrap--align-center"
      >
      <div>
        <div>Opkrævningsinterval</div>
        @if (upcomingChanges.currentOpkraevningsinterval) {
          <strong>Hver {{ upcomingChanges.currentOpkraevningsinterval }} mdr.</strong>
        }
        @if (!upcomingChanges.currentOpkraevningsinterval) {
          <strong>
            Hver {{ serviceaftale.serviceAbonnement.opkraevningInterval }} mdr. (fra abonnement)
          </strong>
        }
      </div>
      <div class="flow__arrow flow__arrow--no-hover">
        <mat-icon class="orange">chevron_right</mat-icon>
      </div>
      <div class="orange">
        <div>
          <div>Opkrævningsinterval</div>
          @if (upcomingChanges.upcomingOpkraevningsinterval) {
            <strong>Hver {{ upcomingChanges.upcomingOpkraevningsinterval }} mdr.</strong>
          }
          @if (!upcomingChanges.upcomingOpkraevningsinterval) {
            <strong>
              Hver {{ upcomingChanges.upcomingServiceabonnement.opkraevningInterval }} mdr. (fra abonnement)
            </strong>
          }
        </div>
      </div>
    </div>
  }

  @if (
    upcomingChanges.currentKundeOpkraevningModel != upcomingChanges.upcomingKundeOpkraevningModel &&
    upcomingChanges.hasKundeOpkraevningModelChanges
    ) {
    <div
      class="flex-wrap flex-wrap--align-center"
      >
      <div>
        <div>Model</div>
        <strong>{{ upcomingChanges.currentKundeOpkraevningModel.text }}</strong>
      </div>
      <div class="flow__arrow flow__arrow--no-hover">
        <mat-icon class="orange">chevron_right</mat-icon>
      </div>
      <div class="orange">
        <div>
          <div>Model</div>
          <strong>{{ upcomingChanges.upcomingKundeOpkraevningModel?.text }}</strong>
        </div>
      </div>
    </div>
  }
</div>
@if (showPartnerChanges && upcomingChanges.hasPartnerChanges) {
  <div>
    <div class="flex-wrap flex-wrap--between flex-wrap--align-center margin--bottom-s">
      <div class="orange icon-with-text">
        <mat-icon svgIcon="obs-solid" class="icon-32"></mat-icon>
        Ændringerne træder i kraft d. {{ upcomingChanges.partnerValidFrom | date: 'dd.MM.yyyy' }}
      </div>
      @if (showRemovePartnerChangesButton) {
        <button [disabled]="!canRemove" class="btn-icon blue" (click)="removePartnerChanges()">
          <mat-icon svgIcon="undo" class="icon-32 blue"></mat-icon>
          <span>Fortryd ændringer</span>
        </button>
      }
    </div>
    <div class="flow__opt-detail flow__opt-detail--has-bg">
      <div class="flex-wrap flex-wrap--align-center">
        <div>
          <strong>{{ upcomingChanges.currentPartner.name }}</strong>
        </div>
        <div class="flow__arrow flow__arrow--no-hover">
          <mat-icon class="orange">chevron_right</mat-icon>
        </div>
        <div class="orange">
          <div>
            <strong>{{ upcomingChanges.upcomingPartner.name }}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
}
